import { Commands } from '.';
var FileExplorerRemoteInput = (function () {
    function FileExplorerRemoteInput(data) {
        this.myAllowTyping = data.AllowTyping;
        this.myData = data.Data;
        this.myId = data.Id;
        this.myMetaData = data.Metadata;
        this.MyTitle = data.Title;
        this.MyShowDownloadOption = data.ShowDownloadOption;
    }
    Object.defineProperty(FileExplorerRemoteInput.prototype, "name", {
        get: function () {
            return Commands.FileExplorerInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "allowTyping", {
        get: function () {
            return this.myAllowTyping;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "data", {
        get: function () {
            return this.myData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "id", {
        get: function () {
            return this.myId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "metaData", {
        get: function () {
            return this.myMetaData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "title", {
        get: function () {
            return this.MyTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "showDownloadOption", {
        get: function () {
            return this.MyShowDownloadOption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileExplorerRemoteInput.prototype, "ModalName", {
        get: function () {
            return 'FileExplorer';
        },
        enumerable: false,
        configurable: true
    });
    return FileExplorerRemoteInput;
}());
export { FileExplorerRemoteInput };
